import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { Api, ApigatewayService } from 'src/app/common/services/apigateway.service';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class QuotationService {
  constructor(private httpClient: HttpClient, private apigatewayService: ApigatewayService) {}

  // private bestApi = this.apigatewayService.getBestApiGateway();
  // private BASE_URL = `${this.bestApi}${env.ARTICO_API_BASE_URL}/quotation`;
  private BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/quotation`;

  save() {
    const URL = this.BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, {});
  }

  update(data: any, id: string) {
    const URL = `${this.BASE_URL}/update/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  get(id: string) {
    const URL = `${this.BASE_URL}/find/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  remove(id: string) {
    const URL = `${this.BASE_URL}/remove/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  find() {
    const URL = `${this.BASE_URL}/find-proposals`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  queryDocument(data: any, id: string) {
    const URL = `${this.BASE_URL}/query-document/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  calculatePrices(data: any, id: string) {
    const URL = `${this.BASE_URL}/calculate-prices/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }
}
